const REPORT_CATEGORY = 'PASSPORT';

const report = (action, name) => {
    if (!window._paq) {
        return;
    }

    (window._paq || []).push(['trackEvent', REPORT_CATEGORY, action, name || ""]);
};

module.exports = { report }


// WEBPACK FOOTER //
// src/service/dasService.js